export interface PackType {
  id: string;
  key: string;
  packDescription: string;
  weight: number;
  height: number;
  width: number;
  depth: number;
  manualTare: boolean;
  manualTareYesNo: string;
}
